import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { AchRelationshipDTO } from '../../../../api/useAchRelationshipsQuery';
import { useUnlinkAccountMutation } from '../../../../api/useUnlinkAccountMutation';
import { useTransferMoneyContext } from '../../../../hooks/useTransferMoneyContext';

interface Props {
  onClose(): void;
  account: AchRelationshipDTO;
}

export const UnlinkAccountModal: React.FC<Props> = ({ onClose, account }) => {
  const { clientId } = useTransferMoneyContext();

  const { mutateAsync: unLinkMutation, isLoading } = useUnlinkAccountMutation();

  return (
    <Modal isOpen onRequestClose={onClose} contentLabel="Delete account">
      <ModalHeader variant="warning">Warning</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Text mt="8">Are you sure you want to delete this account?</Text>

        <Text fontWeight={500} mt="16">
          {account.name}
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" autoFocus mr="8" disabled={isLoading}>
          Cancel
        </Button>

        <Button
          variant="error"
          onClick={async () => {
            await unLinkMutation({ clientId, accountId: account.id });
            onClose();
          }}
          isLoading={isLoading}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
